import { StyleSheet } from 'react-native';

import { isTabletOrWeb } from 'utils/responsiveness';

const styles = StyleSheet.create({
    marker: {
        marginRight: isTabletOrWeb ? 12 : 8,
    },
});

export default styles;
